<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="Kode Bank"
        v-model="searchData.bank_code"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData('bank_code')"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="Kode NNS"
        v-model="searchData.bank_nns"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData('bank_nns')"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="Nama PJSP"
        v-model="searchData.bank_name"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData('bank_name')"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        label="Brand Name"
        v-model="searchData.brand_name"
        type="text"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData('brand_name')"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-menu
        ref="dateMenu"
        v-model="dateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            label="Created Date"
            v-model="dateFormatted"
            v-bind="attrs"
            @blur="searchData.created_at = parseDate(dateFormatted)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData('created_at')"
          />
        </template>
        <v-date-picker
          v-model="searchData.created_at"
          no-title
          scrollable
          @input="dateMenu = false"
        >
          <v-spacer />
          <v-btn text color="primary" @click="dateMenu = false"> Cancel </v-btn>
        </v-date-picker>
      </v-menu>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { formatDate, parseDate } from '../../../lib/helpers';

export default {
  props: ['search', 'options'],
  data: () => ({
    dateFormatted: '',
    dateFormattedLastLogin: '',
    dateMenu: false,
    dateMenuLastLogin: false,
  }),

  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
  },
  watch: {
    'searchData.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.searchData.created_at);
        this.getData();
      },
    },

  },
  beforeDestroy() {
    this.resetFilters();
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
      this.getData();
    },
    clearFilterData(field) {
      this.searchData[field] = ''; 
      this.getData(); 
    },
    formatDate,
    parseDate,
    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
      this.$emit('getDataParent');
    },
  },
};
</script>
